import { z } from 'zod';

const ApplicantSchema = z.object({
  firstName: z.string(),
  middleName: z.string().optional(),
  lastName: z.string(),
  address: z
    .object({
      street: z.string(),
      city: z.string(),
      state: z.string(),
      zip: z.string()
    })
    .nullable()
});

const CoApplicantSchema = z.object({
  firstName: z.string(),
  lastName: z.string()
});

const CreditStatusSchema = z.object({
  hasValidSoftPull: z.boolean(),
  hasErroredSoftPull: z.boolean(),
  hasExpiredSoftPull: z.boolean()
});

const FinancePolicySchema = z.object({
  minMinDown: z.number(),
  startApr: z.number(),
  maxTerm: z.number(),
  maxPayment: z.number(),
  totalDown: z.number().optional()
});

export const CreditApplicationSchema = z.object({
  applicant: ApplicantSchema.nullable(),
  baseFinancingPolicy: FinancePolicySchema.optional(),
  coapplicant: CoApplicantSchema.nullable().optional(),
  coApplicantEligibility: z.object({
    stateAbbreviation: z.string(),
    coBorrowerAllowed: z.boolean(),
    coSignerAllowed: z.boolean()
  }),
  coApplicantToggleOn: z.boolean(),
  creditApplicationExpirationUtc: z.string(),
  creditApplicationId: z.string(),
  creditApplicationPricingUtc: z.string(),
  creditStatus: CreditStatusSchema,
  error: z.string().nullable().optional(),
  financingPolicy: FinancePolicySchema.optional(),
  hasCoApplicant: z.boolean(),
  hasTradeIn: z.boolean()
});
